import { render, staticRenderFns } from "./LinkCopied.vue?vue&type=template&id=6de88c20"
import script from "./LinkCopied.vue?vue&type=script&lang=js"
export * from "./LinkCopied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports